import Cookies from "js-cookie";
import { appAxios } from "../axios/axios";
import { useAppDispatch, useAppSelector } from "../store";
import { useEffect } from "react";
import { setUserData } from "../slice/userDataSlice";

export const useAppAxios = () => {
  const logoutUrlRedux = useAppSelector(
    (state) => state?.siteData?.moduleUrls?.logout
  );
  const dispatch = useAppDispatch();

  const setInterceptors = () => {
    appAxios.interceptors.request.use(
      (config) => {
        if (config.headers) {
          const siteData = localStorage.getItem("siteData");

          const authToken = Cookies.get("auth-token");
          if (authToken) {
            config.headers["auth-token"] = authToken;
          }
          if (siteData) {
            config.headers["site-id"] = JSON.parse(siteData || "")._id;
          }
        }
        // if (config.headers) {
        //   return new Promise((resolve) => {
        //     const interval = setInterval(() => {
        //       const siteData = localStorage.getItem("siteData");
        //       if (config.headers) {
        //         if (siteData) {
        //           const authToken = Cookies.get("auth-token");
        //           if (authToken) {
        //             config.headers["auth-token"] = authToken;
        //           }
        //           config.headers["site-id"] = JSON.parse(siteData || "")._id;
        //           clearInterval(interval);
        //           resolve(config);
        //         }
        //       }
        //     }, 100);
        //   });
        // }

        return config;
      },

      (error) => Promise.reject(error)
    );
    appAxios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response) {
          if (error.response.status === 401) {
            dispatch(setUserData(undefined));
            const logoutUrl = logoutUrlRedux || "/app/logout";
            window.location.href =
              logoutUrl +
              `?redirectTo=${
                window.location.pathname + window.location.search
              }&redirectType=external`;
          }
          return Promise.reject(error.response);
        }
        return Promise.reject(error);
      }
    );
  };

  useEffect(() => {
    setInterceptors();
  }, [logoutUrlRedux]);
  return;
};
